import { EditProductContextProvider } from "./EditProductView";
import EditProduct from "./views/EditProduct";

export const EditProductPage = () => {
  return (
    <EditProductContextProvider>
      <EditProduct />
    </EditProductContextProvider>
  );
};
